var _circle, _ellipse, _ellipse2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 4.36364,
    r: 4.36364,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6363,
    cy: 4.36364,
    rx: 3.27273,
    ry: 3.27273,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.36355,
    cy: 4.36364,
    rx: 3.27273,
    ry: 3.27273,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2563 15.2727H22.8948C23.4864 15.2727 23.9399 14.7625 23.8017 14.1873C23.4192 12.5964 22.3612 9.81818 19.6362 9.81818C18.6695 9.81818 17.9127 10.1678 17.3213 10.69C18.9661 11.7571 19.8165 13.6257 20.2563 15.2727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67848 10.69C6.08711 10.1678 5.33024 9.81818 4.3636 9.81818C1.63863 9.81818 0.580593 12.5964 0.198111 14.1873C0.0598163 14.7625 0.513316 15.2727 1.10494 15.2727H3.74347C4.1832 13.6257 5.03366 11.7571 6.67848 10.69Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9091C16.1115 10.9091 17.1238 14.6282 17.3731 16.4595C17.4476 17.0068 17.0068 17.4545 16.4545 17.4545H7.54541C6.99313 17.4545 6.55235 17.0068 6.62683 16.4595C6.87608 14.6282 7.88841 10.9091 12 10.9091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.22ce295bc3ecc005ea34372042605ece.svg";
export { ForwardRef as ReactComponent };